import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { ToastProvider } from "@heroui/react";

import { AdminAuthProvider } from "@src/auth/AdminAuthProvider";
import { router } from "@src/router";
import "@src/styles.css";

const rootEl = document.getElementById("root");
if (rootEl) {
  createRoot(rootEl).render(
    <React.StrictMode>
      <AdminAuthProvider>
        <RouterProvider router={router} />
        <ToastProvider placement="top end" />
      </AdminAuthProvider>
    </React.StrictMode>,
  );
}
